import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { injectIntl } from 'react-intl';

const GridTotals = ({ data }) => {
  return (
    <Grid
      container
      sx={{
        padding: '0 16px',
        marginTop: '20px',
      }}
    >
      {data.map((item, index) => {
        return (
          <Grid
            key={index}
            sx={{
              marginLeft: index > 0 ? '10px' : '',
            }}
          >
            <Typography
              variant="h5"
              sx={{
                color: '#41424E',
              }}
            >
              <Box
                component={'span'}
                sx={{
                  marginRight: '8px',
                }}
              >
                {item.fieldName}
              </Box>
              <Box
                component={'span'}
                sx={{
                  marginRight: '8px',
                  fontWeight: 700,
                }}
              >
                {item.value}
              </Box>
            </Typography>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default GridTotals;
